import type { UserDetails, TeamDetails } from "../action/ActionType";

export const INITIAL: unknown[] = [];
export const userDetails: UserDetails = {
  profilePic: localStorage.getItem("PROFILE_PIC"),
  userName: localStorage.getItem("LOGIN_NAME"),
};
export const teamDetails: TeamDetails = {
  companyLogo: localStorage.getItem("BRAND_LOGO"),
};
